<template>
  <div class="section">
    <div class="container mb-2">
      <div class="row">
        <div class="col-md-5">
          <template v-if="emailSent">
            <div class="card" style="margin-top:20px;">
              <div class="card-body">
                <div class="media">
                  <img
                    :src="dukaURL+'assets/sent.png'"
                    alt
                    style="width:120px; height:120px; margin:0 auto;"
                    class="img img-responsive align-self-center mr-3"
                  />
                  <div class="media-body">
                    <h5 class="g-font-weight-600">Activate your email</h5>An email containing instructions to create your account is sent to
                    <br />If you don't create account with 24 hours, the link we sent you will be expired.
                  </div>
                </div>
              </div>
            </div>
          </template>
          <form
            @submit.prevent="addCustomer"
            ref="customerForm"
            autocomplete="off"
            class="features_axi_box active mt-3 rounded"
            v-else
          >
            <div class="text-center">
              <h4 class="h4 font-weight-600 mb-2">Join Us!</h4>
            </div>

            <div class="form-group">
              <span class="input-group-addon" :class="{'new-addon': errors.has('Firstname')}">
                <i class="icon-user"></i>
              </span>
              <input
                class="form-control"
                name="Fullname"
                v-validate="'required'"
                type="text"
                v-model="customer.fullname"
                placeholder="Firstname and lastname"
                :class="{'is-invalid': errors.has('Fullname')}"
              />
              <div class="invalid-feedback">{{ errors.first('Fullname') }}</div>
            </div>
            <div class="form-group">
              <input
                class="form-control"
                type="email"
                v-validate="'required|email'"
                name="email"
                :class="{'is-invalid': errors.has('email')}"
                v-model="customer.email"
                placeholder="Email"
                required
              />
              <div class="invalid-feedback">{{ errors.first('email') }}</div>
            </div>
            <div class="form-group">
              <vue-tel-input
                v-model="customer.phone_number"
                :inputClasses="'form-control'"
                :placeholder="'Phone number'"
                :defaultCountry="'Rwanda'"
                :validCharactersOnly="true"
              />
            </div>
            <!--
            <div class="form-group">
              <input
                class="form-control"
                name="Location"
                v-validate="'required'"
                type="text"
                v-model="customer.location"
                placeholder="Your Country"
                :class="{'is-invalid': errors.has('Location')}"
              />
              <div class="invalid-feedback">{{ errors.first('Location') }}</div>
            </div>
            -->
            <div class="form-group">
              <input
                class="form-control rounded g-px-20 g-py-12"
                type="password"
                v-validate="'required'"
                name="password"
                :class="{'is-invalid': errors.has('password')}"
                placeholder="Password"
                ref="password"
                v-model="customer.password"
              />
              <div class="invalid-feedback">{{ errors.first('password') }}</div>
            </div>

            <div class="form-group">
              <input
                class="form-control rounded g-px-20 g-py-12"
                type="password"
                v-validate="'required|confirmed:password'"
                name="Password Confirmation"
                :class="{'is-invalid': errors.has('Password Confirmation')}"
                data-vv-as="password"
                placeholder="Confirm Password"
              />
              <div class="invalid-feedback">{{ errors.first('Password Confirmation') }}</div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-12">
                <div class="alert fade show g-brd-around g-brd-primary rounded-0" role="alert">
                  <p>You will receive an email containing instructions to activate your account</p>
                </div>
              </div>
            </div>-->

            <div class="d-flex flex-wrap justify-content-between padding-bottom-1x">
              <div class="mb-2">
                <p>
                  When you Register,
                  you agree to our
                  <a href="#">User Agreement</a>
                  and
                  <a href="#">User Privacy Notice</a>.
                </p>
              </div>
            </div>
            <div class="text-center">
              <button type="submit" class="btn btn-gradient btn-block">Save and Continue</button>
            </div>
          </form>
        </div>
        <div class="col-md-6 mx-auto pr-0">
          <div class>
            <h4 class="text-center">
              <span class="text-custom">Invoice Management App</span>
            </h4>
            <div class="d-flex w-100">
              <img :src="dukaURL+'assets/images/home_side.jpg'" class="img-fluid mx-auto" />
            </div>
            <div class="home_content mt-1">
              <p
                class="home_small_content mt-4 text-muted"
              >Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dignissimos reprehenderit odit hic!</p>
              <div class="pt-1 text-center">
                <a href="#" class="btn btn-gradient text-uppercase mr-2">Contact US</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
export default {
  name: "SignUp",
  components: {
    VueTelInput
  },
  data: () => ({
    customer: {
      fullname: null,
      location: null,
      email: null,
      phone_number: null,
      password: null
    },
    emailSent: false
  }),
  created() {},
  methods: {
    addCustomer() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var formData = this.formData(this.customer);
          let url = "ap/set-customer";
          let DispatchpParams = { formData: formData, url: url };
          this.$store
            .dispatch("authRequest", DispatchpParams)
            .then(response => {
              if (!response.data.error) window.location.replace("/account");
            });
        }
      });
    }
  }
};
</script>